import Vue from 'vue'
const state = {
  dictMap: {},
  dictLabel: {}
}

const mutations = {
  ADD_DICT: (state, { dictType, dict }) => {
    if (!state.dictMap[dictType]) {
      Vue.set(state.dictMap, dictType, [])
    }
    state.dictMap[dictType].splice(0)
    state.dictMap[dictType].push(...dict)

    const labelCache = state.dictLabel[dictType]
    if (!labelCache) {
      Vue.set(state.dictLabel, dictType, {})
    }
    for (const d of dict) {
      Vue.set(labelCache, d.value, d.label)
    }
  },
  PLACEHOLD_LABEL: (state, { dictType, value }) => {
    if (!state.dictLabel[dictType]) {
      Vue.set(state.dictLabel, dictType, {})
    }
    if (!state.dictLabel[dictType][value]) {
      Vue.set(state.dictLabel[dictType], value, value)
    }
  }
}
const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
